import { html, render } from "lit-html"
import { repeat } from "lit-html/directives/repeat"
import { virtual, useRef, useState } from "haunted"
import Modal from "../generic/modal"
import { ref } from "../directives"

const RACE_ETHNICITY_CATEGORIES = [
  "American Indian/Native American",
  "Asian",
  "Black/Of African Descent",
  "Hawaiian/Pacific Islander",
  "Latinx/Hispanic",
  "Southwest Asian/North African",
  "White",
  "Not listed",
  "Prefer not to disclose",
]

const MODAL_TITLE_ID = "event-reg-modal-title"

export const EventRegForm = ({
  title,
  action,
  showDemographics,
  csrftoken,
  onCancel,
  onSubmit = null,
}) => html`<form method="POST" action=${action}>
  <div class="detail-card relative p-0">
    <header class="modal-header">
      <h1 id="${MODAL_TITLE_ID}" class="text-xl font-bold">${title}</h1>
      <div class="flex flex-row">
        <button
          type="button"
          class="button mr-2 close-modal"
          @click=${onCancel}
        >
          Cancel
        </button>
        <button type="submit" class="button button-submit" @click=${onSubmit}>
          Register
        </button>
      </div>
    </header>
    <div class="content event-reg overflow-y-scroll px-5 py-9">
      <p>One last thing before you register:</p>
      <p>
        Please take a moment to help us ensure we are reaching people across the
        region by telling us a bit about yourself. This information will be used
        to improve outreach and engagement efforts within the Documenters
        network.
      </p>
      <input type="hidden" name="csrfmiddlewaretoken" value=${csrftoken} />
      ${showDemographics
        ? html`<label class="font-bold flex mt-6" for="event_reg_zip_code"
              >ZIP Code</label
            >
            <input
              id="event_reg_zip_code"
              class="input"
              type="text"
              name="zip_code"
            />
            <label class="font-bold flex mt-6" for="event_reg_zip_code"
              >Race/ethnicity (select all that apply)</label
            >
            ${repeat(
              RACE_ETHNICITY_CATEGORIES,
              (c) => c,
              (category, idx) => html`
                <label
                  class="flex flex-row items-center mt-4"
                  for="event_reg_race_${idx}"
                >
                  <input
                    id="event_reg_race_${idx}"
                    name="race_ethnicity"
                    type="checkbox"
                    value=${category}
                  />
                  <span tabindex="-1"> ${category} </span>
                </label>
              `
            )}
            <label class="font-bold flex mt-6" for="event_reg_sex"
              >Gender identification</label
            >
            <input id="event_reg_sex" class="input" type="text" name="sex" />`
        : ``}
      <label class="font-bold flex mt-6" for="event_reg_how_heard">
        Did you hear about this workshop from an organization?
      </label>
      <input
        id="event_reg_how_heard"
        class="input"
        type="text"
        name="how_heard"
      />
      <p class="text-small">
        If so, let us know which one so we can thank them
      </p>
    </div>
  </div>
</form>`

const EventRegButtonForm = virtual(({ className = ``, ...props }) => {
  const buttonRef = useRef(null)
  const [open, setOpen] = useState(false)

  const csrftoken = document.head.querySelector("meta[name='csrf-token']")
    .content

  const onClose = () => {
    setOpen(false)

    if (buttonRef.current) {
      buttonRef.current.focus()
    }
  }

  return html`<button
      type="button"
      class="button button-submit ${className}"
      ?ref=${ref(buttonRef)}
      @click=${() => setOpen(!open)}
    >
      ${props.title}
    </button>
    ${open
      ? Modal({
          children: EventRegForm({ ...props, csrftoken, onCancel: onClose }),
          labelledBy: MODAL_TITLE_ID,
          onClose,
        })
      : ``}`
})

export default EventRegButtonForm

export function renderEventRegButtonForm(el) {
  const {
    event_reg_form: { title, action, show_demographics: showDemographics },
  } = JSON.parse(
    document.querySelector(`[type="application/json"][data-props]`).innerText
  )

  render(
    EventRegButtonForm({
      title,
      action,
      showDemographics,
    }),
    el
  )
}
